import { Component, OnInit } from '@angular/core';

import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss',
  standalone: false
})
export class LogoutComponent implements OnInit {
  constructor(private msalService: MsalService) { }

  async ngOnInit() {
    await this.msalService.instance.initialize();

    this.msalService.logoutRedirect({
      postLogoutRedirectUri: '/login'
    });
  }
}
